import basic from './basic';
import rectangularBlock from './rectangularBlock';
import horizontalTree from './horizontalTree';
import cola from './cola';

export default {
  basic: basic.render,
  traditional: rectangularBlock.render,
  horizontalTree: horizontalTree.render,
  cola: cola.render
 }
